const actions = {
  setSelectedNote({ commit }, selectedNote) {
    commit("SET_SELECTED_NOTE", selectedNote);
  },

  setSelectedDataOnSped({ commit }, selectedDataOnSped) {
    commit("SET_SELECTED_DATA_ON_SPED", selectedDataOnSped);
  },

  setAllSelectedDataOnNfe({ commit }, allSelectedDataOnNfe) {
    commit("SET_ALL_SELECTED_DATA_ON_NFE", allSelectedDataOnNfe);
  },
  setShowAccountsGrid({ commit }, showAccountsGrid) {
    commit("SET_SHOW_ACCOUNTS_GRID", showAccountsGrid);
  },
  setDidChangeCta({ commit }, didChangeCta) {
    commit("SET_DID_CHANGE_CTA", didChangeCta);
  },
  setSelectedSped({ commit }, selectedSped) {
    commit("SET_SELECTED_SPED", selectedSped);
  },
  setCfopList({ commit }, cfopList) {
    commit("SET_CFOP_LIST", cfopList);
  },
  setFavoriteAccounts({ commit }, favoriteAccounts) {
    commit("SET_FAVORITE_ACCOUNTS", favoriteAccounts);
  },
  setIsMovIcms({ commit }, isMovIcms) {
    commit("SET_IS_MOV_ICMS", isMovIcms);
  },
  setLastNoteOpen({ commit }, lastNoteOpen) {
    commit("SET_LAST_NOTE_OPEN", lastNoteOpen);
  },
  setKeysSelectedToSum({ commit }, keysSelectedToSum) {
    commit("SET_KEYS_SELECTED_TO_SUM", keysSelectedToSum);
  },
  setSelectedKeysToShowSped({ commit }, selectedKeysToShowSped) {
    commit("SET_SELECTED_KEYS_TO_SHOW_SPED", selectedKeysToShowSped);
  },
  setSelectedKeysToShowNfe({ commit }, selectedKeysToShowNfe) {
    commit("SET_SELECTED_KEYS_TO_SHOW_NFE", selectedKeysToShowNfe);
  },
  setSelectedNoteVlIcmsClient({ commit }, selectedNoteVlIcmsClient) {
    commit("SET_SELECTED_NOTE_VL_ICMS_CLIENT", selectedNoteVlIcmsClient);
  },
  setViewOnlyMode({ commit }, viewOnlyMode) {
    commit("SET_VIEW_ONLY_NODE", viewOnlyMode);
  },
};

export default actions;
